import { Link } from "react-router-dom";

/**
 * CellLink — a navigation link for use inside PMDataTable cells.
 *
 * Clicking it navigates to `to` and stops the click from bubbling up to the
 * row's onClick handler (which opens the right detail drawer). This lets a
 * single row support both behaviours: click a key cell (e.g. the number or the
 * customer name) to navigate, click anywhere else to open the drawer.
 *
 * Renders a non-navigating span when `to` is falsy.
 */
export const CellLink = ({ to, children, className = "", title }) => {
  if (!to) {
    return (
      <span className={className} title={title}>
        {children}
      </span>
    );
  }
  return (
    <Link
      to={to}
      title={title}
      onClick={(e) => e.stopPropagation()}
      className={`cursor-pointer rounded-sm hover:underline focus:underline focus:outline-none ${className}`}
    >
      {children}
    </Link>
  );
};

export default CellLink;
